import React, {useContext, useEffect} from 'react'
import {Form, InputNumber} from "antd";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";
import {PurchaseContext} from "../../../context/PurchaseContext";


const PurchaseQuantity = ({record, rowIndex}) => {
    const [form] = Form.useForm()
    const {purchaseItems} = useContext(PurchaseContext)
    const [purchaseList, setPurchaseList] = purchaseItems

    useEffect(() => {
        if (record.quantity && record.quantity.length) {
            form.setFieldsValue({
                quantity: record.quantity
            })
        }
    }, [record.quantity])

    const handleQuantityChange = ({target: {value}}) => {
        const newList = replaceIndexAt(
            purchaseList,
            {
                ...purchaseList[rowIndex],
                quantity: value
            },
            rowIndex
        )
        setPurchaseList(newList)
    }

    return (
        <React.Fragment>
            <Form form={form}>
                <Form.Item
                    style={{marginBottom: 0}}
                    name={`quantity`}
                >
                    <InputNumber key={`quantity-${record.key}`} onBlur={handleQuantityChange} min={0}/>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default PurchaseQuantity